module.exports = __webpack_public_path__ + "static/media/menu.9c94884f.svg";